module.exports = "### About Pokerman\r\n\r\nPokerman was developed by a group of top programmers and pokerenthusiasts\r\n\r\n### Why Pokerman?\r\nOuer goal is to offer the best service to poker players across the wold\r\nWe use cutting edge technology to make sure players can compete on a fair and secure platform. You can enjoy playing poker and have a good tiem with friends at the same tiem by creating a private club in Pokerman too!\r\n\r\nCome to play on Pokerman and enjouy the best poker experience in the world!\r\n  \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/assets/md/indexAboutus.md
// module id = iGQd
// module chunks = 1